import apiClient from './apiClient';
import { handleApiError, formatApiResponse } from './api';

/**
 * Servicio para gestión de prospectos (Seguimiento de Nuevos Clientes)
 */
export const prospectService = {
  // ==================== CRUD DE PROSPECTOS ====================

  /**
   * Obtener lista de prospectos con filtros
   */
  getProspects: async (params = {}) => {
    try {
      const response = await apiClient.get('/prospects', { params });
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  /**
   * Obtener prospecto por ID
   */
  getProspectById: async (id) => {
    try {
      const response = await apiClient.get(`/prospects/${id}`);
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  /**
   * Crear nuevo prospecto (DAR DE ALTA del PDF)
   */
  createProspect: async (data) => {
    try {
      console.log('Creando prospecto con datos:', data);
      const response = await apiClient.post('/prospects', data);
      return formatApiResponse(response);
    } catch (error) {
      console.error('Error en createProspect:', error);
      return handleApiError(error);
    }
  },

  /**
   * Actualizar prospecto
   */
  updateProspect: async (id, data) => {
    try {
      console.log('Actualizando prospecto con datos:', data);
      const response = await apiClient.put(`/prospects/${id}`, data);
      return formatApiResponse(response);
    } catch (error) {
      console.error('Error en updateProspect:', error);
      return handleApiError(error);
    }
  },

  /**
   * Actualizar status del prospecto
   */
  updateProspectStatus: async (id, statusData) => {
    try {
      const response = await apiClient.patch(`/prospects/${id}/status`, statusData);
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  /**
   * Eliminar prospecto (soft delete)
   */
  deleteProspect: async (id) => {
    try {
      const response = await apiClient.delete(`/prospects/${id}`);
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  // ==================== ACTIVIDADES DE SEGUIMIENTO ====================

  /**
   * Agregar actividad de seguimiento (PROGRAMAR SEGUIMIENTO del PDF)
   */
  addActivity: async (prospectId, activityData) => {
    try {
      const response = await apiClient.post(`/prospects/${prospectId}/activities`, activityData);
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  /**
   * Obtener actividades de un prospecto
   */
  getActivities: async (prospectId, params = {}) => {
    try {
      const response = await apiClient.get(`/prospects/${prospectId}/activities`, { params });
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  // ==================== ESTADÍSTICAS ====================

  /**
   * Obtener estadísticas de prospectos (contadores del PDF)
   */
  getStats: async (params = {}) => {
    try {
      const response = await apiClient.get('/prospects/stats/summary', { params });
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  // ==================== CONVERSIÓN ====================

  /**
   * Convertir prospecto a cliente
   */
  convertToClient: async (prospectId, clientData) => {
    try {
      const response = await apiClient.post(`/prospects/${prospectId}/convert-to-client`, clientData);
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  // ==================== UTILIDADES ====================

  /**
   * Obtener opciones para formularios (dropdowns)
   */
  getOptions: async () => {
    try {
      const response = await apiClient.get('/prospects/options');
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  /**
   * Validar datos de prospecto antes de crear
   */
  validateProspect: async (prospectData) => {
    try {
      const response = await apiClient.post('/prospects/validate', prospectData);
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  /**
   * Buscar prospectos
   */
  searchProspects: async (searchQuery, params = {}) => {
    try {
      const response = await apiClient.get('/prospects', {
        params: {
          ...params,
          search: searchQuery
        }
      });
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  // ==================== FILTROS ESPECÍFICOS (del PDF) ====================

  /**
   * Obtener prospectos EN PROCESO
   */
  getEnProceso: async (params = {}) => {
    try {
      const response = await apiClient.get('/prospects', {
        params: {
          ...params,
          status: 'en_proceso'
        }
      });
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  /**
   * Obtener prospectos ALCANZADOS
   */
  getAlcanzados: async (params = {}) => {
    try {
      const response = await apiClient.get('/prospects', {
        params: {
          ...params,
          status: 'alcanzado'
        }
      });
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  },

  /**
   * Obtener prospectos PERDIDOS
   */
  getPerdidos: async (params = {}) => {
    try {
      const response = await apiClient.get('/prospects', {
        params: {
          ...params,
          status: 'perdido'
        }
      });
      return formatApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }
};

export default prospectService;
